export const CATEGORY_STYLES = {
  Exercise: {
    dot: "#3B82F6",
    badge: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800",
    bar: "bg-blue-500",
    icon: "Activity",
  },
  Medication: {
    dot: "#8B5CF6",
    badge: "bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-950/40 dark:text-purple-300 dark:border-purple-800",
    bar: "bg-purple-500",
    icon: "Pill",
  },
  Appointment: {
    dot: "#F97316",
    badge: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/40 dark:text-orange-300 dark:border-orange-800",
    bar: "bg-orange-500",
    icon: "CalendarClock",
  },
  "Wound Care": {
    dot: "#EF4444",
    badge: "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-800",
    bar: "bg-red-500",
    icon: "Bandage",
  },
  Diet: {
    dot: "#10B981",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
    bar: "bg-emerald-500",
    icon: "Apple",
  },
};

export function riskLevel(score) {
  if (score <= 30) return "low";
  if (score <= 60) return "moderate";
  return "high";
}

export const RISK_STYLES = {
  low: {
    label: "Routine",
    tier: "Routine",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
    bar: "bg-emerald-500",
    ring: "ring-emerald-300",
    accent: "#10B981",
  },
  moderate: {
    label: "Needs Attention",
    tier: "Needs Attention",
    badge: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
    bar: "bg-amber-500",
    ring: "ring-amber-300",
    accent: "#F59E0B",
  },
  high: {
    label: "High-Risk",
    tier: "High-Risk",
    badge: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800",
    bar: "bg-rose-600",
    ring: "ring-rose-300",
    accent: "#EF4444",
  },
};

export function tierFromRisk(score) {
  if (score <= 30) return "Routine";
  if (score <= 60) return "Needs Attention";
  return "High-Risk";
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const now = new Date();
  const diffMin = Math.round((now - d) / 60000);
  if (diffMin < 1) return "just now";
  if (diffMin < 60) return `${diffMin}m ago`;
  const h = Math.round(diffMin / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.round(h / 24);
  return `${days}d ago`;
}

export function computeRecoveryDay(surgeryDate) {
  if (!surgeryDate) return 1;
  const sd = new Date(surgeryDate);
  const diff = Math.floor((Date.now() - sd.getTime()) / 86400000) + 1;
  return Math.max(1, Math.min(diff, 20));
}

export function progressForDay(tasks, day) {
  const dayTasks = tasks.filter((t) => t.day === day);
  if (dayTasks.length === 0) return { pct: 0, done: 0, total: 0 };
  const done = dayTasks.filter((t) => t.done).length;
  return { pct: Math.round((done / dayTasks.length) * 100), done, total: dayTasks.length };
}
